import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchOpenCourses } from "../../reduxSlices/openCoursesSlice";
import {
  Card,
  CardHeader,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from "@material-ui/core";
import TablePagination from "@material-ui/core/TablePagination";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import DeleteIcon from "@material-ui/icons/Delete";

const OpenCourses = () => {
  const dispatch = useDispatch();
  const { openCoursesData, loading, error } = useSelector(
    (state) => state.openCourses,
  );

  useEffect(() => {
    const contactId = window.localStorage.getItem("x-auth-contactId");
    if (contactId) {
      dispatch(fetchOpenCourses(contactId));
    }
  }, [dispatch]);

  // Handle both array and { data: array } response formats
  let data = [];
  if (Array.isArray(openCoursesData)) {
    data = openCoursesData;
  } else if (openCoursesData && Array.isArray(openCoursesData.data)) {
    data = openCoursesData.data;
  }

  const filteredData = data.filter((row) => {
    return row.ses_class || row.ses_coursename || row.ses_section;
  });

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    if (page > 0 && page * rowsPerPage >= filteredData.length) {
      setPage(Math.max(0, Math.ceil(filteredData.length / rowsPerPage) - 1));
    }
  }, [filteredData.length, rowsPerPage, page]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  return (
    <div style={{ flex: 1, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Card elevation={3} style={{ width: '100%', height: '100%' }}>
        <CardHeader title="Open Courses" />
        <CardContent style={{ padding: 16, height: '100%' }}>
          <TableContainer
            component={Paper}
            style={{ width: '100%', maxHeight: 350, overflowY: 'auto', overflowX: 'auto' }}
          >
            <Table size="small">
              <TableHead>
                <TableRow style={{ background: "#1976d2" }}>
                  <TableCell style={{ color: "#fff", fontWeight: "bold", whiteSpace: 'nowrap', wordBreak: 'normal', minWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    Class ID
                  </TableCell>
                  <TableCell style={{ color: "#fff", fontWeight: "bold", whiteSpace: 'nowrap', wordBreak: 'normal', minWidth: 140, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    Course
                  </TableCell>
                  <TableCell style={{ color: "#fff", fontWeight: "bold", whiteSpace: 'nowrap', wordBreak: 'normal', minWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    Class Section
                  </TableCell>
                  <TableCell style={{ color: "#fff", fontWeight: "bold", whiteSpace: 'nowrap', wordBreak: 'normal', minWidth: 80, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    Credits
                  </TableCell>
                  <TableCell style={{ color: "#fff", fontWeight: "bold", whiteSpace: 'nowrap', wordBreak: 'normal', minWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    Class Status
                  </TableCell>
                  <TableCell style={{ color: "#fff", fontWeight: "bold", whiteSpace: 'nowrap', wordBreak: 'normal', minWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    Status
                  </TableCell>
                  <TableCell style={{ color: "#fff", fontWeight: "bold", whiteSpace: 'nowrap', wordBreak: 'normal', minWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    Attendance
                  </TableCell>
                  <TableCell style={{ color: "#fff", fontWeight: "bold", whiteSpace: 'nowrap', wordBreak: 'normal', minWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    Grading Option
                  </TableCell>
                  <TableCell style={{ color: "#fff", fontWeight: "bold", whiteSpace: 'nowrap', wordBreak: 'normal', minWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    Terms
                  </TableCell>
                  <TableCell style={{ color: "#fff", fontWeight: "bold", whiteSpace: 'nowrap', wordBreak: 'normal', minWidth: 80, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={10} style={{ textAlign: "center" }}>
                      Loading...
                    </TableCell>
                  </TableRow>
                ) : error ? (
                  <TableRow>
                    <TableCell
                      colSpan={10}
                      style={{ textAlign: "center", color: "red" }}
                    >
                      {error}
                    </TableCell>
                  </TableRow>
                ) : paginatedData && paginatedData.length > 0 ? (
                  paginatedData.map((row, idx) => (
                    <TableRow
                      key={row.ses_sessionid || idx}
                      style={idx % 2 ? { background: "#f9f9f9" } : {}}
                    >
                      <TableCell style={{ whiteSpace: 'nowrap', wordBreak: 'normal', minWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.ses_class || "-"}</TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap', wordBreak: 'normal', minWidth: 140, overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.ses_coursename || "-"}</TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap', wordBreak: 'normal', minWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.ses_section || "-"}</TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap', wordBreak: 'normal', minWidth: 80, overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.ses_creditstaken ?? "-"}</TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap', wordBreak: 'normal', minWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.ses_classstatus || "-"}</TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap', wordBreak: 'normal', minWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.ses_studentstatus || "-"}</TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap', wordBreak: 'normal', minWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {row.ses_sessionpercenttodate != null ? (
                          <>
                            {row.ses_sessionpercenttodate}%
                            <IconButton size="small">
                              <AddCircleOutlineIcon fontSize="small" />
                            </IconButton>
                          </>
                        ) : (
                          "-"
                        )}
                      </TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap', wordBreak: 'normal', minWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.ses_gradeoption || "-"}</TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap', wordBreak: 'normal', minWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.ses_termname || "-"}</TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap', wordBreak: 'normal', minWidth: 80, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        <IconButton size="small" color="secondary">
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={10} style={{ textAlign: "center" }}>
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default OpenCourses;
